export const IFRAME_ID = 'web-messenger-container';
